import React from 'react'
import PropTypes from 'prop-types'

const BarChartIcon = (props) => {
  const { color = '#000000', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M17.8544 13.3208H18.8624C19.1503 13.3208 19.4383 13.0317 19.4383 12.7427V2.33766C19.4383 2.04863 19.1503 1.7596 18.8624 1.7596H17.8544C17.5665 1.7596 17.2785 2.04863 17.2785 2.33766V12.7427C17.2785 13.0317 17.5665 13.3208 17.8544 13.3208ZM9.2152 13.3208H10.2231C10.5111 13.3208 10.7991 13.0317 10.7991 12.7427V3.7828C10.7991 3.49377 10.5111 3.20474 10.2231 3.20474H9.2152C8.92722 3.20474 8.63925 3.49377 8.63925 3.7828V12.7427C8.63925 13.0317 8.92722 13.3208 9.2152 13.3208ZM13.5348 13.3208H14.5427C14.8307 13.3208 15.1187 13.0317 15.1187 12.7427V6.67309C15.1187 6.38406 14.8307 6.09503 14.5427 6.09503H13.5348C13.2468 6.09503 12.9589 6.38406 12.9589 6.67309V12.7427C12.9589 13.0317 13.2468 13.3208 13.5348 13.3208ZM22.3181 15.4885H2.15981V1.03703C2.15981 0.637804 1.83764 0.314453 1.43987 0.314453H0.719937C0.322172 0.314453 0 0.637804 0 1.03703V16.211C0 17.009 0.644794 17.6562 1.43987 17.6562H22.3181C22.7158 17.6562 23.038 17.3328 23.038 16.9336V16.211C23.038 15.8118 22.7158 15.4885 22.3181 15.4885ZM4.89557 13.3208H5.90349C6.19146 13.3208 6.47944 13.0317 6.47944 12.7427V9.56338C6.47944 9.27435 6.19146 8.98532 5.90349 8.98532H4.89557C4.6076 8.98532 4.31962 9.27435 4.31962 9.56338V12.7427C4.31962 13.0317 4.6076 13.3208 4.89557 13.3208Z"
        fill={color}
      />
    </svg>
  )
}

BarChartIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(BarChartIcon)
